// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"e_kB","legend":"e_lB","legendContent":"e_mB","contentWrapper":"e_nB","fieldsetContent":"e_oB"};